/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const SocialExportRudoPublishDtoRestrictionEnum = {
    "0": 0,
    "1": 1,
    "2": 2
} as const;

export type SocialExportRudoPublishDtoRestrictionEnumKey = (typeof SocialExportRudoPublishDtoRestrictionEnum)[keyof typeof SocialExportRudoPublishDtoRestrictionEnum];

export type SocialExportRudoPublishDto = {
    /**
     * @description Default Rudo folder id for uploads
     * @type integer
    */
    folderId?: number | null;
    /**
     * @description VOD restriction: 0 = off (default), 1 = premium, 2 = registration only
     * @type number
    */
    restriction?: SocialExportRudoPublishDtoRestrictionEnumKey | null;
    /**
     * @description Video title (max 200 characters)
     * @minLength 1
     * @maxLength 200
     * @type string
    */
    title: string;
    /**
     * @description Video description
     * @type string
    */
    description?: string | null;
    /**
     * @description List of tags
     * @type array
    */
    tags?: string[] | null;
    /**
     * @description Thumbnail URL (jpg, jpeg, or png)
     * @type string, uri
    */
    thumbnailUrl?: string | null;
};